import { useTranslation } from 'react-i18next';
import { Section, SectionSubHeader } from '../../common';
import { Customer } from '../../types';
import CustomerInput from './CustomerInput';

interface Props {
    customer: Customer;
    accountId: string;
}

const Consents = ({ customer, accountId }: Props) => {
    const { t } = useTranslation();

    if (!customer.marketing_consent) return null;
    return (
        <Section>
            <SectionSubHeader>{t('customers.fields.consents')}</SectionSubHeader>

            <CustomerInput
                formElement="checkbox"
                name="marketing_consent.email.consent"
                accountId={accountId}
                customer={customer}
                label={t('customers.fields.consent_types.email')}
                value={!!customer.marketing_consent?.email?.consent}
            />

            <CustomerInput
                formElement="checkbox"
                name="marketing_consent.sms.consent"
                accountId={accountId}
                customer={customer}
                label={t('customers.fields.consent_types.sms')}
                value={!!customer.marketing_consent?.sms?.consent}
            />
        </Section>
    );
};

export default Consents;
